// ===========================================
// FEEDBACK MODAL STORE
// ===========================================
// Controls the feedback/support modal state globally
// Allows any component to open the feedback modal

import { create } from 'zustand';

// ===========================================
// TYPES
// ===========================================

type FeedbackType = 'feedback' | 'support' | null;

interface FeedbackStoreState {
  // Current modal type (null = closed)
  feedbackType: FeedbackType;

  // Actions
  openFeedback: () => void;
  openSupport: () => void;
  close: () => void;
}

// ===========================================
// STORE
// ===========================================

export const useFeedbackStore = create<FeedbackStoreState>((set) => ({
  feedbackType: null,

  openFeedback: () => set({ feedbackType: 'feedback' }),
  openSupport: () => set({ feedbackType: 'support' }),
  close: () => set({ feedbackType: null }),
}));
